<template>
  <v-card :loading="loading">
    <v-form ref="form">
      <v-container>
        <fieldset>
          <v-row>
            <v-col cols="12">
              <non-form-field-errors :errors="errors"></non-form-field-errors>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Class Name</label>
              <v-text-field
                :error-messages="errors.class_name"
                v-model="data.class_name"
                required
                :rules="rules.class_name"
                label="Class"
                placeholder="Class"
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Subjects</label>
              <v-select
                :error-messages="errors.subjects_ids"
                required
                v-model="data.subjects_ids"
                :items="subjects"
                label="Choose Subject"
                placeholder="Choose Subject"
                solo
                :rules="rules.subjects"
                multiple
                item-text="subject_name"
                item-value="subject_id"
                append-outer-icon="mdi mdi-plus"
                @click:append-outer="addSubject = true"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Per Hour Charge</label>
              <v-text-field
                :error-messages="errors.fare_per_hour"
                required
                v-model="data.fare_per_hour"
                type="number"
                :rules="rules.fare_per_hour"
                hint="Charges based on the per hour session"
                persistent-hint
                label="Fare"
                placeholder="Fare"
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <label class="custom-label">Class Code</label>
              <v-text-field
                :error-messages="errors.class_code"
                required
                v-model="data.class_code"
                :rules="rules.class_code"
                label="Class Code"
                placeholder="Class Code"
                solo
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-btn :loading="loading" color="primary" @click="save"
                >Save</v-btn
              >
            </v-col>
          </v-row>
        </fieldset>
      </v-container>
    </v-form>
    <subject-add-dialog
      @subjectSaved="getSubjects"
      @subjectCancelled="addSubject = false"
      :show="addSubject"
    >
    </subject-add-dialog>
  </v-card>
</template>

<script>
import SubjectAddDialog from "../classes/subjects/SubjectAddDialog";
import NonFormFieldErrors from "../utils/errors/NonFormFieldErrors";
export default {
  name: "ClassForm",
  components: { NonFormFieldErrors, SubjectAddDialog },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      subjects: [],
      loading: true,
      data: {
        class_code: "",
        name: "",
        subjects_ids: [],
        fare: 0,
      },
      errors: {},
      rules: {
        class_code: [(value) => !!value || "Class Code is Required"],
        name: [(value) => !!value || "Name is Required"],
        subjects: [(values) => !!values || "At least on Subject is required"],
        fare: [
          (value) => parseFloat(value) > 0 || "Fare should be greater  then 0",
        ],
      },
      addSubject: false,
    };
  },
  methods: {
    getSubjects() {
      this.addSubject = false;
      axios
        .get("subjects")
        .then((response) => {
          this.subjects = response.data.subjects;
        })
        .catch((error) => {
          // console.log(error.response)
          if (error.response.status === 400) {
            this.errors = error.response.data;
          }
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        });
    },
    save() {
      this.loading = true;
      if (this.id) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      axios
        .post(apiRoutes.classes.url, this.data)
        .then((response) => {
          this.errors = {};
          this.data = {
            name: "",
            class_code: "",
            subjects_ids: [],
            fare: 0,
          };
          this.loading = false;
          this.$router.replace({ name: "SettingClass" });
        })
        .catch((error) => {
          // console.log(error.response)
          if (error.response.status === 400) {
            this.errors = error.response.data;
          }
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        });
    },
    update() {
      axios
        .patch(apiRoutes.classes.url + "/" + this.id, this.data)
        .then((response) => {
          this.errors = {};
          this.loading = false;
          this.$router.replace({ name: "SettingClass" });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.errors = error.response.data;
          }
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getSubjects();
    this.loading = false;
    if (this.id) {
      // alert(this.id)
      this.loading = true;
      axios.get(apiRoutes.classes.url + "/" + this.id).then((response) => {
        // console.log(response.data)
        this.data.fare_per_hour = response.data.fare_per_hour;
        this.data.class_name = response.data.class_name;
        this.data.class_code = response.data.class_code;
        this.data.subjects_ids = [
          ...response.data.class_subject_group.map((subject) =>
            parseInt(subject.subject_id)
          ),
        ];
        this.loading = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
fieldset {
  border: 0;

  &:not(:last-of-type) {
    border-bottom: 1px dashed #8898aa80;
    margin-bottom: 20px;
  }

  & legend {
    font: Bold 20px/25px Lato;
    color: #172b4d;
  }

  & label {
    font: Bold 15px/40px Lato;
    color: #172b4d;
  }
}
</style>